import { __read } from "tslib";
import Color from 'color';
export var isColor = function (val) {
    return val ? /(^#([a-f\d]{3}){1,2}$)|(^rgba?\(\d+(,\d+){2,3}(\.\d+)?\)$)/i.test(val.replace(/\s/g, '')) : false;
};
var isRgbValues = function (val) { return (val ? /^\d+(,\d+){2,3}(\.\d+)?$/.test(val.replace(/\s/g, '')) : false); };
var isHexValue = function (val) { return (val ? /(^#([a-f\d]{3}){1,2}$)/i.test(val.replace(/\s/g, '')) : false); };
var rgbToHexString = function (rgb) { return "#" + rgb.map(function (channel) { return channel.toString(16); }).join(''); };
var getColor = function (color) {
    if (isColor(color)) {
        return Color(color);
    }
    if (isRgbValues(color)) {
        return Color("rgba(" + color + ")");
    }
    if (color === 'transparent') {
        return Color.rgb(0, 0, 0, 0);
    }
    return null;
};
var isThemeColor = function (color) { return /^color_\d+$/.test(color); };
var brighten = function (colorString, brightnessModifier) {
    if (brightnessModifier === void 0) { brightnessModifier = 1; }
    var color = getColor(colorString);
    if (!color) {
        return null;
    }
    var hsvColor = color.hsv();
    return hsvColor
        .value(hsvColor.value() * brightnessModifier)
        .rgb()
        .string();
};
var getRGBAColorString = function (color, colorOpacity) {
    if (colorOpacity === void 0) { colorOpacity = 1; }
    return Color(fixColor(color))
        .alpha(colorOpacity)
        .string();
};
var splitColor = function (rgbString) {
    return Color(rgbString)
        .array()
        .join(',');
};
/**
 * Returns rgb values string from a hex color string input (i.e 255,255,255), null if value given is not a hex color
 * @param value a string value that might be a color
 */
var getSplitRgbValuesString = function (value) {
    var color = getColor(value);
    if (!color) {
        return null;
    }
    return color
        .rgb()
        .array()
        .join(',');
};
var getColorAlpha = function (value) {
    var color = getColor(value);
    if (!color) {
        return null;
    }
    return color.alpha();
};
/**
 * Given theme color string e.g {color_1} / [color_1] extracts the underlying color - color_1
 * @param str theme color
 */
var extractThemeColor = function (str) {
    return str.replace(new RegExp('[\\[\\]{}]', 'g'), '');
};
var getFromColorMap = function (rawColor, colorsMap) {
    if (colorsMap === void 0) { colorsMap = []; }
    var _a = __read(extractThemeColor(rawColor).split('_'), 2), themeColorIndex = _a[1];
    var i = parseInt(themeColorIndex, 10);
    return typeof i === 'number' && isNaN(i) === false ? colorsMap[i] : rawColor;
};
var isGreyscale = function (colorObj) {
    return colorObj.red() === colorObj.green() && colorObj.red() === colorObj.blue() && colorObj.red() !== 255;
};
var getHexColor = function (rgbAsString) {
    var color = getColor(rgbAsString);
    return color && color.hex().toString();
};
var getColorClass = function (className) {
    var findColorClass = /(color_\d+)/;
    var colorClass = findColorClass.exec(className);
    return colorClass && colorClass[1];
};
var fixColor = function (color) {
    if (isColor(color)) {
        return color;
    }
    return color.replace(';', '');
};
var formatColor = function (value, alpha) {
    var fixedColor = fixColor(value);
    var color = new Color(fixedColor).alpha(Number(alpha));
    var formattedRgbColor = color
        .rgb()
        .toString()
        .replace(/ /g, '');
    return Number(alpha) !== 1
        ? formattedRgbColor
        : formattedRgbColor.replace(/^rgb/, 'rgba').replace(')', "," + color.alpha() + ")");
};
var getColorFromCssStyle = function (value) {
    var red = value.red, green = value.green, blue = value.blue, alpha = value.alpha;
    var color = new Color(rgbToHexString([red, green, blue]));
    return formatColor(color.toString(), alpha);
};
var extractRGBA = function (value) {
    var rgbaRe = /rgba\([^)]+\)/;
    var result = value.match(rgbaRe);
    if (result && result[0]) {
        return result[0];
    }
    return '';
};
export { brighten, extractThemeColor, getRGBAColorString, splitColor, getFromColorMap, getSplitRgbValuesString, getHexColor, getColorAlpha, getColorClass, formatColor, isGreyscale, isThemeColor, isRgbValues, isHexValue, getColorFromCssStyle, extractRGBA, };
//# sourceMappingURL=color.js.map